<template>
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.8327 16.103c0 .4598-.3728.8314-.8326.8314-.45985 0-.83257-.3716-.83257-.8314 0-.4586.37272-.8349.83257-.8349.4598-.0011.8326.3751.8326.8349ZM9.17699 12.7846c0 .455.36804.8231.82311.8231.4551 0 .8231-.3681.8243-.8231 0-.5069.4857-1.1771 1.1136-1.5311 1.1959-.6902 1.9391-1.97669 1.9391-3.35603 0-1.036-.4033-2.00967-1.1359-2.74225-.7315-.7326-1.7052-1.13594-2.7399-1.13594h-.00237c-1.03485 0-2.00735.40334-2.73988 1.13594-.73263.73258-1.13597 1.70625-1.13597 2.74225 0 .45507.36804.82313.82316.82313.45502 0 .82317-.36806.82317-.82313 0-.59622.23275-1.15711.65491-1.5781.42104-.42096.98074-.65262 1.57578-.65262h.0012c.595 0 1.1548.23166 1.5757.65262.4209.42216.6527.98188.6527 1.5781 0 .79254-.4281 1.53338-1.1089 1.92614-1.14425.64679-1.94381 1.86379-1.94381 2.96099Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0001 20C4.48611 20 0 15.5127 0 10 0 4.48612 4.48611 0 10.0001 0 15.5128 0 20 4.48612 20 10c0 5.5127-4.4872 10-9.9999 10Zm0-18.35372c-4.60619 0-8.35377 3.74764-8.35377 8.35372 0 4.6061 3.74758 8.3537 8.35377 8.3537 4.606 0 8.3537-3.7476 8.3537-8.3537 0-4.60608-3.7477-8.35372-8.3537-8.35372Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconQuestionMark",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
